<template>
    <div>
        <div class="width100">
            <div class="clear"></div>
            <div
                class="shadow width100 paddingbottom10"
                style="margin-bottom: 50px"
            >
                <div class="width100">
                    <ul class="nolist tabs">
                        <Tab
                            v-if="cabins['Binnenhut']"
                            width="width25"
                            title="Binnenhut"
                            :activeTab="activeType === 'Binnenhut'"
                            @click="setType('Binnenhut')"
                        />
                        <li class="width2"></li>
                        <Tab
                            v-if="cabins['Buitenhut']"
                            width="width25"
                            title="Buitenhut"
                            :activeTab="activeType === 'Buitenhut'"
                            @click="setType('Buitenhut')"
                        />
                        <li class="width2"></li>
                        <Tab
                            v-if="cabins['Balkonhut']"
                            width="width25"
                            title="Balkonhut"
                            :activeTab="activeType === 'Balkonhut'"
                            @click="setType('Balkonhut')"
                        />
                        <li class="width2"></li>
                        <Tab
                            v-if="cabins['Suite']"
                            width="width25"
                            title="Suite"
                            :activeTab="activeType === 'Suite'"
                            @click="setType('Suite')"
                        />
                        <li class="width2"></li>
                    </ul>
                </div>
                <div class="mainbox">
                    <div>
                        <ul class="tabList nolist nomargin verticalmenu">
                            <li
                                v-for="(cabin, index) in cabins[activeType]"
                                :key="'cabinsActiveType' + index"
                                v-on:click="setActiveBar(index)"
                            >
                                <a
                                    class="faciliteit bar"
                                    :class="activeBar === index ? 'active' : ''"
                                >
                                    {{
                                        cabin.naam + ' (' + cabin.code + ')'
                                    }}</a
                                >
                            </li>
                        </ul>
                        <div class="right">
                            <img
                                class="tabImage"
                                :src="activeHutType('img_url')"
                                :alt="activeType + '-image'"
                            />

                            <div class="subText margintop20">
                                <span class="subTitle" style="margin-top: -10px"
                                    >{{
                                        activeHutType('naam') +
                                            ' (' +
                                            activeHutType('code') +
                                            ')'
                                    }} </span
                                ><br />
                                <span>
                                    {{ activeHutType('omschrijving') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tab from './Tab.vue'

export default {
    name: 'Entertainment',
    components: {
        Tab,
    },
    data: function() {
        return {
            activeType: 'Binnenhut',
            activeBar: 0,
        }
    },
    computed: {
        cabins: function() {
            let cabins = {}
            if (this.$store.state.cabins.collection) {
                this.$store.state.cabins.collection.map(cabin => {
                    //Give every word a capital letter
                    cabin.naam = this.capitalize(cabin.naam)

                    //Create types
                    if (!cabins[cabin.type]) {
                        cabins[cabin.type] = []
                    }

                    //Combine duplicate huts
                    let alreadyInArr = false
                    cabins[cabin.type].map(arrCabin => {
                        if (
                            arrCabin.naam === cabin.naam &&
                            arrCabin.omschrijving.trim() ===
                                cabin.omschrijving.trim()
                        ) {
                            alreadyInArr = true
                            arrCabin.code = arrCabin.code + ', ' + cabin.code
                        }
                    })

                    //Push into types
                    if (!alreadyInArr) {
                        cabins[cabin.type].push(cabin)
                    }
                })
            }
            return cabins
        },
    },
    methods: {
        activeHutType: function(type) {
            if (this.cabins[this.activeType] && type) {
                return this.cabins[this.activeType][this.activeBar][type]
            }
        },
        setType: function(type) {
            this.setActiveBar(0)
            this.activeType = type
        },
        setActiveBar: function(index) {
            this.activeBar = index
        },
        capitalize: function(s) {
            if (typeof s !== 'string') return ''
            return s
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        },
    },
}
</script>

<style scoped>
.tabs {
}
.mainbox {
    margin-top: 56px;
    margin-right: 12px;
    margin-bottom: 40px;
}
a {
    font-weight: normal !important;
}
a:hover:after,
a:hover {
    text-decoration: none !important;
    border-top-color: #37b5d3;
    background: #37b5d3 !important;
    color: white !important;
}

.bar {
    font-weight: bold;
    font-size: 14px;
    height: calc(57px - 16px);
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px;
}
.active,
.active:after,
.active:hover {
    color: white !important;
    font-weight: bold !important;
    font-size: 14px;
    background: #37b5d3 !important;
    border-top-color: #37b5d3;
}
.right {
    width: calc(100% - 10px);
    padding: 10px;
    padding-top: 0px;
    float: left;
    z-index: 2;
    position: relative;
}
.tabList {
    width: calc(100% - 4px);
    float: left;
    border-top: 1px solid white;
}

.subTitle {
    font-weight: bold;
    color: #37b5d3;
    font-size: 16px;
}
@media screen and (min-width: 900px) {
    .tabList {
        width: 200px;
    }
    .bar {
        width: 150px;
    }
    .bar::after {
        background: #37b5d3;
        border: 28.5px solid #fff;
        border-left-color: #37b5d3;
    }
    .bar:hover:after {
        background: #37b5d3;
        border: 28.5px solid #fff;
        border-left-color: #37b5d3;
    }
    .bar:hover {
        background: #37b5d3;
        border-left-color: #37b5d3;
    }
    .right {
        max-width: 510px;
    }
}
@media screen and (max-width: 900px) {
    .verticalmenu .active::after {
        border: 0 !important;
    }
}
</style>
